import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetMovimientosByPadre = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.get(`/movimientos-contenedores/padre/${params.mov}/${params.alm}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getMovimientosByPadreMutation: mutation.mutate,
    };
}